import { AlertIcon as ChakraAlertIcon } from '@chakra-ui/react';

type AlertIconProps = React.ComponentProps<typeof ChakraAlertIcon>;

const AlertIcon = ({ ...props }: Readonly<AlertIconProps>) => {
  return <ChakraAlertIcon {...props} />;
};

export default AlertIcon;
